var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Doorbell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 17.21c-6.44 0-11.84 4.88-13.13 11.84L19.6 56H32v1.28A2.72 2.72 0 0034.72 60h6.55A2.72 2.72 0 0044 57.28V56h12.41l-5.28-26.94c-1.3-6.98-6.69-11.85-13.13-11.85zM24.51 52l4.34-22.15c.93-5 4.7-8.55 9.15-8.55s8.22 3.52 9.15 8.55L51.5 52H24.51z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Doorbell.91fab4d9.svg";
export { SvgG1Doorbell as ReactComponent };